import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories as categoriesData } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || '');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [activeSlug]);

  const currentCategory = categoriesData.find((c) => c.slug === activeSlug);
  const articles = getArticlesByCategory(activeSlug);
  const categoryName = currentCategory?.name || '';

  return (
    <>
      <SEOHead
        title={`${categoryName} - 爱爱网`}
        description={currentCategory?.description || `浏览爱爱网${categoryName}分类下的所有专业文章，获取优质的亲密关系与情感指导。`}
        keywords={`${categoryName},爱爱网,两性知识,情感指导`}
      />
      <Navbar />
      <main className="pt-20 pb-14 min-h-screen bg-background-50">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: categoryName },
            ]}
          />

          <header className="mt-6 mb-10">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              {categoryName}
            </h1>
            <p className="text-sm md:text-base text-foreground-500">
              {currentCategory?.description}
            </p>
          </header>

          <div className="flex flex-wrap gap-2 mb-8">
            {categoriesData.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200/70 hover:text-foreground-800'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                <i className="ri-file-list-3-line text-2xl text-foreground-300"></i>
              </div>
              <p className="text-foreground-400 text-sm">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}